<template>
  <div>
    <b-card>
      <b-card-header>Sign Out</b-card-header>
      <b-card-body>
        See you again soon!
        <br/><br/>
        <i class="fa fa-hand-paper-o" aria-hidden="true"></i>
        Bye.
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Logout",
  async mounted() {
    await this.sleep(3000);
    this.$store.dispatch("signoutUser");
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
};
</script>

<style>
</style>